module.exports = __webpack_public_path__ + "img/tb(2).1312d3a9.png";